module.exports = __webpack_public_path__ + "static/media/Slied Way logo.430933ed.png";